import React, { useContext, useEffect, useRef, useState } from 'react';
import './styles.scss';
import StepWizard from 'react-step-wizard';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {
  EmergencyInputField,
  GenericButton,
  GenericModal,
  InputField,
  MaterialInputField,
  InsuranceInputField,
  ActionButtons,
  PhoneInputField,
} from 'components';
import Grid from '@mui/material/Grid';
import {
  businessSignUpStep2Schema,
  businessSignUpStep3Schema,
  signUpSchema,
} from 'common/schemas';
import { Formik } from 'formik';
import { ENUMS, constants, countriesList } from 'common';
import { images } from 'common/images';
import PasswordStrengthBar from 'react-password-strength-bar';
import { Link, useNavigate, useParams } from 'react-router-dom';

import {
  checkIfCompanyExists,
  checkIfEmailExists,
  getUserByEmail,
  getUserDetails,
  performBusinessSignUpThroughFirebase,
  performLoginThroughFirebase,
  performSignUpThroughFirebase,
  saveUserData,
} from 'services/firebaseServices';
import {
  generateAndSendOtpCode,
  verifyOtpCode,
} from 'utilities/otpService';
import {
  getProfile,
  getTempUserDetail,
  setProfile,
  setSecondaryProfile,
  setToken,
} from 'utilities/localStorage';
import { routePaths } from 'routes';
import { useSearchParams } from 'react-router-dom';

import { Navigation } from 'components/navigation';

import { Checkbox, CircularProgress, FormControlLabel } from '@mui/material';
import { MedicalCard } from 'components/medical-card';
import { industryOptions } from 'common/countries';
import { auth } from 'services';
import { onAuthStateChanged } from 'firebase/auth';

const {
  formHeadings: { step1, step8, step9, step7 },
  pleaseFilloutPersonalInfo,
  alreadyHaveAndAcc,
} = constants;

export const converDateFormate = (dateString) => {
  const originalDate = new Date(dateString);
  const formattedDate = originalDate.toLocaleDateString('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  return formattedDate;
};
const SignUp = () => {
  let navigate = useNavigate();
  const { company } = useParams();
  const isCompanyLogin = !!company;
  const [btnLoader, setBtnLoader] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { wmcLogo } = images;
  const [activeStep, setActiveStep] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState({
    type: ENUMS.MODAL_TYPES.ERROR,
    title: '',
    body: '',
  });
  const [userDetails, setUserDetails] = useState({
    // Step 1 — Account Info (from signUpSchema)
    email: '',
    password: '',
    confirmPassword: '',
    phone: '',

    // Step 2 — Business Info (from businessSignUpStep2Schema)
    companyName: '',
    industry: '',

    // Step 3 — Address Info (from businessSignUpStep3Schema)
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
  });

//   const [countryCode, setCountryCode] = useState('us');
//     useEffect(() => {
//       async function getUserCountry() {
//         try {
//           // Call IP geolocation API
//           const response = await fetch('https://ipwho.is/');
//           const data = await response.json();
//           console.log("country code ===", data.country_code.toLowerCase())
  
//           if (data.country_code) {
//             setCountryCode(data.country_code.toLowerCase());
//           }
//         } catch (err) {
//           console.error("IP API Error:", err);
//         }
//       }
  
//       getUserCountry();
//     }, []);
// console.log("country code === outside",countryCode);

  const handleStepChange = (e) => {
    setActiveStep(e.activeStep - 1);
  };

  function Step1(props) {
    return (
      <Formik
        initialValues={userDetails}
        validateOnMount={true}
        onSubmit={(values) => {
          setUserDetails((data) => ({
            ...data,
            ...values,
          }));
          checkEmail(values, props);
        }}
        validationSchema={signUpSchema}
        enableReinitialize
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          touched,
          errors,
          values,
          setFieldValue,
          setFieldError,
        }) => {
          const handleEmailBlur = async (e) => {
            handleBlur(e);
            const emailValue = e.target.value;
            if (emailValue && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
              // Query Firestore directly — avoids Firebase Email Enumeration Protection
              // which silently breaks fetchSignInMethodsForEmail
              const existingDoc = await getUserByEmail(emailValue);
              if (existingDoc) {
                setFieldError('email', 'This email address is already registered.');
              }
            }
          };

          return (
          <div className='sign-up-step-cont'>
            <div>
              <div className='sign-up-form-heading'>
                <span>{'Sign Up'}</span>
              </div>
              <Grid container spacing={0.7}>
                <Grid item xs={12} xl={12} lg={12} md={12}>
                  <MaterialInputField
                    // icon={<Email/>}
                    name={'email'}
                    id={'email'}
                    placeholder={'Email'}
                    label={'Email'}
                    error={touched.email && errors.email}
                    handleChange={handleChange}
                    handleBlur={handleEmailBlur}
                    value={values.email}
                  />
                </Grid>
                <Grid item xs={12} xl={12} lg={12} md={12}>
                  <MaterialInputField
                    customStyle={'pass-input-custom-style'}
                    id={'password'}
                    name={'password'}
                    placeholder={'Password'}
                    label={'Password'}
                    error={touched.password && errors.password}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    value={values.password}
                    isPassword
                  />
                  {values.password != '' && (
                    <PasswordStrengthBar password={values.password} />
                  )}
                </Grid>
                <Grid item xs={12} xl={12} lg={12} md={12}>
                  <MaterialInputField
                    customStyle={'pass-input-custom-style'}
                    id={'confirmPassword'}
                    name={'confirmPassword'}
                    placeholder={'Confirm Password'}
                    label={'Confirm Password'}
                    error={touched.confirmPassword && errors.confirmPassword}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    value={values.confirmPassword}
                    isPassword
                    isSearch
                  />
                  {values.confirmPassword != '' && (
                    <PasswordStrengthBar password={values.confirmPassword} />
                  )}
                </Grid>
                <Grid item xs={12} xl={12} lg={12} md={12}>
                  <PhoneInputField
                    name={'phone'}
                    id={'phone'}
                    value={values.phone}
                    handleChange={handleChange('phone')}
                    handleBlur={handleBlur('phone')}
                    specialLabel={'Phone Number'}
                    error={touched.phone && errors.phone}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={values.marketingConsent}
                        onChange={(e) =>
                          setFieldValue('marketingConsent', e.target.checked)
                        }
                        color='primary'
                      />
                    }
                    label='I agree to receive marketing emails and updates.'
                  />
                </Grid>
                <div className='error-input-container'>
                  {touched.marketingConsent && errors.marketingConsent ? (
                    <p className='form-error'>{errors.marketingConsent}</p>
                  ) : null}
                </div>
              </Grid>
            </div>
            <ActionButtons
              handleSubmit={handleSubmit}
              activeStep={activeStep}
              {...props}
            />
          </div>
          );
        }}
      </Formik>
    );
  }

  function Step2(props) {
    return (
      <Formik
        initialValues={userDetails}
        validateOnMount={true}
        onSubmit={(values) => {
          setUserDetails((data) => ({
            ...data,
            ...values,
          }));
          checkCompany(values, props);
        }}
        validationSchema={businessSignUpStep2Schema}
        enableReinitialize
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          touched,
          errors,
          values,

          isSubmitting,
        }) => (
          <div className='sign-up-step-cont'>
            <div className='sign-up-form-heading'>
              <span>{'Company Detail'}</span>
            </div>
            <Grid container spacing={0.7}>
              <Grid item xs={12}>
                <MaterialInputField
                  name='companyName'
                  id='companyName'
                  label='Company Name'
                  placeholder='Company Name'
                  error={touched.companyName && errors.companyName}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  value={values.companyName}
                />
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <InputLabel id='industry-label'>Industry *</InputLabel>
                    <Select
                      labelId='industry-label'
                      name='industry'
                      value={values.industry}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      sx={{
                        boxShadow: 'none',
                        '.MuiOutlinedInput-notchedOutline': {
                          border: 0,
                        },
                      }}
                    >
                      {industryOptions.map(({ value, label }, index) => (
                        <MenuItem key={index} value={value}>
                          {label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                {errors.industry && touched.industry && (
                  <p className='form-error'>{errors.industry}</p>
                )}
              </Grid>
            </Grid>
            <ActionButtons
              handleSubmit={handleSubmit}
              activeStep={activeStep}
              {...props}
            />
          </div>
        )}
      </Formik>
    );
  }

  function Step3(props) {
    return (
      <div className='checkout-cont'>
        <Formik
          initialValues={userDetails}
          validationSchema={businessSignUpStep3Schema}
          onSubmit={(values) => {
            setUserDetails((data) => ({
              ...data,
              ...values,
            }));
            props.nextStep();
          }}
          validateOnMount
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            touched,
            errors,
            values,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit} className='sign-up-step-cont'>
              <div
                className='sign-up-form-heading'
                style={{ marginTop: '1.5rem' }}
              >
                <span>Address Details</span>
              </div>

              <Grid container spacing={0.7} mb={1}>
                <Grid item xs={12} md={6}>
                  <MaterialInputField
                    name='addressLine1'
                    label='Address Line 1'
                    placeholder='Address Line 1'
                    error={touched.addressLine1 && errors.addressLine1}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    value={values.addressLine1}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <MaterialInputField
                    name='addressLine2'
                    label='Address Line 2'
                    placeholder='Address Line 2'
                    error={touched.addressLine2 && errors.addressLine2}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    value={values.addressLine2}
                  />
                </Grid>

                <Grid item xs={12}>
                  <MaterialInputField
                    name='city'
                    label='City'
                    placeholder='City'
                    error={touched.city && errors.city}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    value={values.city}
                  />
                </Grid>

                <Grid item xs={12}>
                  <MaterialInputField
                    name='state'
                    label='State / Province'
                    placeholder='State / Province'
                    error={touched.state && errors.state}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    value={values.state}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth>
                      <InputLabel id='country-label'>Country *</InputLabel>
                      <Select
                        labelId='country-label'
                        name='country'
                        value={values.country}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        sx={{
                          boxShadow: 'none',
                          '.MuiOutlinedInput-notchedOutline': {
                            border: 0,
                          },
                        }}
                      >
                        {countriesList.map(({ value, label }, index) => (
                          <MenuItem key={index} value={value}>
                            {label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  {errors.country && touched.country && (
                    <p className='form-error'>{errors.country}</p>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <MaterialInputField
                    name='postalCode'
                    label='Postal Code'
                    placeholder='Postal Code'
                    error={touched.postalCode && errors.postalCode}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    value={values.postalCode}
                  />
                </Grid>
              </Grid>

              {/* Action Buttons inside form for access to handleSubmit */}
              <ActionButtons
                activeStep={activeStep}
                handleSubmit={handleSubmit}
                {...props}
                // createAccount='Create Business Account'
                isSubmitting={isLoading}
              />
            </form>
          )}
        </Formik>
      </div>
    );
  }

  function Step7(props) {
    const [emailVerified, setEmailVerified] = useState(false);
    const [sendingCode, setSendingCode] = useState(true);
    const [sendError, setSendError] = useState('');
    const [otpValue, setOtpValue] = useState('');
    const [otpError, setOtpError] = useState('');
    const [verifying, setVerifying] = useState(false);
    const [resendModalOpen, setResendModalOpen] = useState(false);
    const [currentUid, setCurrentUid] = useState(null);
    const emailSentRef = useRef(false);

    useEffect(() => {
      if (!props.isActive) return;

      const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
        if (user && !emailSentRef.current) {
          emailSentRef.current = true;
          setCurrentUid(user.uid);
          try {
            setSendingCode(true);
            await generateAndSendOtpCode(user.uid, userDetails.email || user.email);
            setSendError('');
          } catch (err) {
            setSendError('Failed to send verification email. Use Resend below.');
          } finally {
            setSendingCode(false);
          }
        }
      });

      return () => {
        unsubscribeAuth();
      };
    }, [props.isActive]);

    const handleVerify = async () => {
      if (!otpValue || otpValue.length !== 6) {
        setOtpError('Please enter the 6-digit code from your email.');
        return;
      }
      setVerifying(true);
      setOtpError('');
      try {
        const result = await verifyOtpCode(currentUid, otpValue);
        if (result.success) {
          setEmailVerified(true);
        } else {
          setOtpError(result.message || 'Invalid code. Please try again.');
        }
      } catch (err) {
        setOtpError('Something went wrong. Please try again.');
      } finally {
        setVerifying(false);
      }
    };

    const handleResend = async () => {
      if (!currentUid) return;
      try {
        setSendingCode(true);
        setSendError('');
        setOtpValue('');
        setOtpError('');
        await generateAndSendOtpCode(currentUid, userDetails.email, true);
        setResendModalOpen(true);
      } catch (err) {
        setSendError('Failed to resend. Please try again.');
      } finally {
        setSendingCode(false);
      }
    };

    return (
      <div className='step1-container'>
        <h2 className='step1-heading'>Verify Your Email Address</h2>
        <p className='step1-subheading'>
          We've sent a 6-digit code to{' '}
          <strong>{userDetails.email}</strong>. Enter it below to continue.
        </p>

        <div className='step1-status'>
          {sendingCode ? (
            <div className='loading-indicator'>
              <CircularProgress color='success' size={24} />
              <p>Sending verification code...</p>
            </div>
          ) : emailVerified ? (
            <p className='status-message verified'>Your email is verified! ✅</p>
          ) : (
            <div className='otp-input-container'>
              {sendError && (
                <p className='status-message not-verified'>{sendError}</p>
              )}
              <input
                type='text'
                inputMode='numeric'
                maxLength={6}
                value={otpValue}
                onChange={(e) => {
                  setOtpValue(e.target.value.replace(/\D/g, '').slice(0, 6));
                  setOtpError('');
                }}
                placeholder='Enter 6-digit code'
                className='otp-input'
              />
              {otpError && <p className='form-error'>{otpError}</p>}
              <button
                className='otp-verify-btn'
                onClick={handleVerify}
                disabled={verifying || otpValue.length !== 6}
              >
                {verifying ? (
                  <>
                    <CircularProgress color='inherit' size={16} />
                    {' '}Verifying...
                  </>
                ) : (
                  'Verify Code'
                )}
              </button>
            </div>
          )}
        </div>

        <div className='button-container'>
          <p className='resend-button' onClick={handleResend}>
            Resend Code
          </p>
        </div>

        <div className='action-buttons'>
          <ActionButtons
            setUserDetails={setUserDetails}
            userDetails={userDetails}
            createAccount='Create Business Account'
            isSubmitting={isLoading}
            disableNext={!emailVerified}
            handleSubmit={() => {
              if (!emailVerified) return;
              performSignUp(auth.currentUser, props);
            }}
            {...props}
          />
        </div>

        <GenericModal
          show={resendModalOpen}
          title='A new verification code has been sent to your email!'
          handleClose={() => setResendModalOpen(false)}
          buttonText={constants.ok}
          type={5}
        />
      </div>
    );
  }
  // UPDATED STEPS - Removed step2, step3, step5 (moved to post-login modals)
  const steps = [step1, step8, step9, step7];

  const performSignUp = async (user, props) => {
    // debugger;
    setIsLoading(true);
    try {
      const { email, password, ...businessData } = userDetails;

      const response = await performBusinessSignUpThroughFirebase({
        email,
        password,
        businessData,
        user,
      });

      if (!!response) {
        setShowModal(true);
        setApiResponse({
          type: ENUMS.MODAL_TYPES.SUCCESS,
          title: 'Success',
          body: 'Your Account Has been Created',
        });
        // You can redirect or update UI here
      } else {
        setShowModal(true);

        setApiResponse({
          type: ENUMS.MODAL_TYPES.ERROR,
          title: 'Error',
          body: 'Unable to Create Account',
        });
      }
    } catch (error) {
      setShowModal(true);

      setApiResponse({
        type: ENUMS.MODAL_TYPES.ERROR,
        title: 'Error',
        body: 'Unable to Create Account',
      });
    }
    setIsLoading(false);
  };

  const checkEmail = async (payload, props) => {
    const response = await checkIfEmailExists(payload?.email);
    if (response) {
      setUserDetails((data) => ({
        ...data,
        email: payload.email,
        password: payload.password,
        confirmPassword: payload.confirmPassword,
      }));
      performSignUpThroughFirebase({
        email: payload.email,
        password: payload.password,
      });
      props.nextStep();
    } else {
      setApiResponse({
        type: ENUMS.MODAL_TYPES.ERROR,
        title: 'Error',
        body: 'Email already exists.',
      });
      setShowModal(true);
    }
  };
  const checkCompany = async (payload, props) => {
    try {
      const response = await checkIfCompanyExists(payload);

      if (response.exists) {
        // ❌ Business already exists
        setApiResponse({
          type: ENUMS.MODAL_TYPES.ERROR,
          title: 'Duplicate Business',
          body:
            response.message ||
            'A business with this information already exists.',
        });
        setShowModal(true);
        return;
      }

      // ✅ Business does not exist — proceed
      setUserDetails((data) => ({
        ...data,
        email: payload.email,
        password: payload.password,
        confirmPassword: payload.confirmPassword,
      }));

      // Optionally trigger sign-up (uncomment when ready)
      // await performSignUpThroughFirebase({
      //   email: payload.email,
      //   password: payload.password,
      // });

      props.nextStep();
    } catch (error) {
      console.error('Error in checkCompany:', error);
      setApiResponse({
        type: ENUMS.MODAL_TYPES.ERROR,
        title: 'Error',
        body:
          error.message || 'Something went wrong while checking the company.',
      });
      setShowModal(false);
    }
  };

  const performLogin = async (userData) => {
    setBtnLoader(true);
    if (userData) {
      let payload = {
        email: userData?.email,
        password: userData?.password,
      };
      try {
        const result = await performLoginThroughFirebase(payload);
        if (result) {
          const {
            user: { accessToken, uid, reloadUserInfo },
          } = result;
          setToken(accessToken);
          setProfile({
            uid,
            reloadUserInfo,
          });
          const responseData = await getUserDetails(uid);
          setSecondaryProfile(responseData);
          navigate({ pathname: routePaths.business });
        }
        setBtnLoader(true);
        setShowModal(false);
      } catch (e) {
        setShowModal(true);
        setApiResponse({
          type: ENUMS.MODAL_TYPES.ERROR,
          title: 'Error',
          body: e.message,
        });
        setBtnLoader(true);
      }
    }
  };

  return (
    <div className='signin-container'>
      {!isCompanyLogin && <Navigation />}
      <div className='leftPlan' id='leftPlan'>
        <div className='leftPlanInner'>
          <div className='mobile-logo-cont'>
            {isCompanyLogin && (
              <div className='wmcImagBox'>
                <img
                  src={wmcLogo}
                  height='auto'
                  width='100%'
                  alt='no-image'
                  style={{ borderRadius: 0 }}
                />
              </div>
            )}
          </div>
          <div className='mobileImageBox'>
            <MedicalCard {...userDetails} />
          </div>
        </div>
      </div>
      <div className='right-container'>
        <div className='wizard-wrap'>
          <>
            <div className='wmc-heading-text'>
              <h1 className='welcome'>Register a new Business account</h1>
              <p className='signInMsg'>{pleaseFilloutPersonalInfo}</p>
            </div>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <StepWizard onStepChange={handleStepChange}>
              <Step1 />
              <Step2 />
              <Step3 />
              <Step7 />
            </StepWizard>
          </>
          <div className='already-have-an-account-cont'>
            <Link to='/sign-in'>
              <p className='noAccountLink'>{alreadyHaveAndAcc}</p>
            </Link>
          </div>
        </div>
      </div>
      <GenericModal
        show={showModal}
        type={apiResponse.type}
        title={apiResponse.title}
        body={apiResponse.body}
        buttonText={constants.ok}
        btnLoader={btnLoader}
        handleClose={() => {
          if (apiResponse.type == ENUMS.MODAL_TYPES.ERROR) {
            setShowModal(false);
          } else {
            searchParams.delete('seesion_id');
            setSearchParams(searchParams);
            performLogin(userDetails);
          }
        }}
      />
    </div>
  );
};

export default SignUp;
